import type { Currency, Participant, SuggestedTransfer } from "@/api/types";
import { Avatar } from "./Avatar";
import { Button } from "./Button";
import { MoneyAmount } from "./MoneyAmount";
import { participantLabel } from "@/utils/avatar";
import "./paid-transfer-row.css";

export interface PaidTransferRowProps {
  transfer: SuggestedTransfer;
  ccy: Currency;
  participants: ReadonlyArray<Participant>;
  /** Undo — DELETE the settlement (AC-18.2a). */
  onUndo: () => void;
  undoDisabled?: boolean;
}

/**
 * A fully-paid transfer kept on screen as a calm "✓ оплачено" row (AC-18.2b,
 * ADR-0025) — it does not vanish. Carries a "Скасувати" undo affordance.
 */
export function PaidTransferRow({
  transfer,
  ccy,
  participants,
  onUndo,
  undoDisabled,
}: PaidTransferRowProps) {
  const from = participants.find((p) => p.participant_id === transfer.from_participant_id);
  const to = participants.find((p) => p.participant_id === transfer.to_participant_id);
  if (!from || !to) return null;

  const label = `${participantLabel(from)} → ${participantLabel(to)}`;

  return (
    <div className="wp-paid-row" data-testid="paid-transfer-row" aria-label={`Оплачено: ${label}`}>
      <span aria-hidden="true" className="wp-paid-row__check">✓</span>
      <div className="wp-paid-row__people">
        <Avatar participant={from} size="sm" />
        <span aria-hidden="true" className="wp-paid-row__arrow">→</span>
        <Avatar participant={to} size="sm" />
      </div>
      <span className="wp-paid-row__amount">
        <MoneyAmount value={transfer.amount} ccy={ccy} size="body" tone="neutral" />
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={onUndo}
        disabled={undoDisabled}
        aria-label={`Скасувати переказ ${label}`}
      >
        Скасувати
      </Button>
    </div>
  );
}
